module.exports = __webpack_public_path__ + "img/Armenia.3f54e9e2.svg";